unit UUserModel;

interface

uses
  Js, UEssentialHelper, UResultModel;

type
  TUserModel = class
  private
    FName: string;
    FPersonalNr: string;
    FRemote_User: string;
    FVorname: string;
    FOnPropertyChanged: TCallback;
    FNotice: string;
    FEmail: string;
    FInfoMail: Boolean;
    FHandy: string;
    FPlz: string;
    FTelefon: string;
    FStrasse: string;
    FOrt: string;
    FResult: TResultModel;
    FOnError: TErrorEvent;
    function DecodePersonalNr: string;
    procedure ClearValues;
    procedure DoError(AMsg: string);
    procedure PropertyChanged;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetValues(json: string); overload;
    procedure SetName(const Value: string);
    procedure SetPersonalNr(const Value: string);
    procedure SetRemote_User(const Value: string);
    procedure SetVorname(const Value: string);
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetNotice(const Value: string);
    procedure SetEmail(const Value: string);
    procedure SetHandy(const Value: string);
    procedure SetInfoMail(const Value: Boolean);
    procedure SetOrt(const Value: string);
    procedure SetPlz(const Value: string);
    procedure SetStrasse(const Value: string);
    procedure SetTelefon(const Value: string);
    procedure SetResult(const Value: TResultModel);
    procedure SetOnError(const Value: TErrorEvent);
  public
    constructor Create; overload;
    constructor Create(obj: TJsObject); overload;
    constructor Create(json: string); overload;
    class procedure IsPwCorrect(url: string; user: string; passwort: string;
      callback: TCallback; errorCallback: TErrorEvent);
    function ToJson: string;
    function ToString: string; override;
    procedure GetByRemote_User(url: string; remote_User: string);
    procedure GetNotice(url: string);
    procedure Update(url: string);
    procedure UpdateRemoteUser(url: string; remoteUserNew: string);
    procedure UpdatePassword(url: string; newPassword: string);
    property PersonalNr: string read FPersonalNr write SetPersonalNr;
    property Name: string read FName write SetName;
    property Vorname: string read FVorname write SetVorname;
    property remote_User: string read FRemote_User write SetRemote_User;
    property Notice: string read FNotice write SetNotice;
    property Strasse: string read FStrasse write SetStrasse;
    property Plz: string read FPlz write SetPlz;
    property Ort: string read FOrt write SetOrt;
    property Telefon: string read FTelefon write SetTelefon;
    property Handy: string read FHandy write SetHandy;
    property Email: string read FEmail write SetEmail;
    property InfoMail: Boolean read FInfoMail write SetInfoMail;
    property Result: TResultModel read FResult write SetResult;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
  end;

implementation

uses
  WebLib.REST, WebLib.json, WebLib.Storage, WebLib.Controls;

{ TUserModel }

procedure TUserModel.ClearValues;
begin
  Self.PersonalNr := '';
  Self.Name := '';
  Self.Vorname := '';
  Self.remote_User := '';
  Self.Strasse := '';
  Self.Plz := '';
  Self.Ort := '';
  Self.Telefon := '';
  Self.Handy := '';
  Self.Email := '';
  Self.InfoMail := false;
  Self.Result := TResultModel.Create;
end;

constructor TUserModel.Create;
begin
  Self.OnPropertyChanged := nil;
  Self.OnError := nil;
  Self.ClearValues;
end;

constructor TUserModel.Create(obj: TJsObject);
begin
  Self.Create;
  Self.SetValues(obj);
end;

constructor TUserModel.Create(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

function TUserModel.DecodePersonalNr: string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', Self.PersonalNr);
  Result := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', Result);
  Result := obj.ToString;
end;

procedure TUserModel.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TUserModel.GetByRemote_User(url, remote_User: string);
var
  client: TRestClient;
  obj: TJsonObject;
  helper, cmd: string;
  jso: TJsObject;
  procedure Response(Sender: TObject; AResponse: string);
  begin
    Self.ClearValues;
    if AResponse <> '' then
      TLocalStorage.SetValue(cmd, AResponse)
    else
      AResponse := TLocalStorage.GetValue(cmd);
    if AResponse <> '' then
    begin
      jso := TJsJson.parseObject(AResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TUserModel.GetByRemote_User');
  end;

  procedure ErrorHandler(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('Remote_User', remote_User);
  helper := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  cmd := url + '/PersonalService/GetRemoteUser_' + obj.ToString;
  client.HttpsPost(url + '/PersonalService/GetRemoteUser', 'application/json',
    obj.ToString);
end;

procedure TUserModel.GetNotice(url: string);
var
  client: TRestClient;

  procedure Response(Sender: TObject; AResponse: string);
  var
    obj: TJsObject;
  begin
    obj := TJsJson.parseObject(AResponse);
    Self.Notice := string(obj['value']);
    Self.PropertyChanged;
  end;

begin
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(url + '/PersonalService/GetNotice', 'application/json',
    Self.DecodePersonalNr);
end;

class procedure TUserModel.IsPwCorrect(url: string; user: string;
  passwort: string; callback: TCallback; errorCallback: TErrorEvent);
var
  obj: TJsonObject;
  helper, cmd: string;
  client: TRestClient;
  procedure Response(Sender: TObject; AResponse: string);
  var
    jso: TJsObject;
    s: string;
    Value: TBooleanValue;
  begin
    if AResponse <> '' then
      TLocalStorage.SetValue(cmd, AResponse)
    else
      AResponse := TLocalStorage.GetValue(cmd);
    if AResponse <> '' then
    begin
      jso := TJsJson.parseObject(AResponse);
      s := string(jso['value']);
      if s = 'true' then
        Value := TBooleanValue.Create(true)
      else
        Value := TBooleanValue.Create(false);
      if Assigned(callback) then
        callback(Value);
    end
    else if Assigned(errorCallback) then
      errorCallback(nil,
        'Verbindungsfehler: Passwort kann nicht überprüft werden!');
  end;

  procedure ErrorHandler(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Sender, '');
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('Remote_User', user);
  obj.AddPair('Remote_Passwort', passwort);
  helper := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  cmd := url + '/PersonalService/IsPwCorrect_' + obj.ToString;
  client.HttpsPost(url + '/PersonalService/IsPwCorrect', 'application/json',
    obj.ToString);
end;

procedure TUserModel.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TUserModel.SetEmail(const Value: string);
begin
  FEmail := Value;
end;

procedure TUserModel.SetHandy(const Value: string);
begin
  FHandy := Value;
end;

procedure TUserModel.SetInfoMail(const Value: Boolean);
begin
  FInfoMail := Value;
end;

procedure TUserModel.SetName(const Value: string);
begin
  FName := Value;
end;

procedure TUserModel.SetNotice(const Value: string);
begin
  FNotice := Value;
end;

procedure TUserModel.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TUserModel.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TUserModel.SetOrt(const Value: string);
begin
  FOrt := Value;
end;

procedure TUserModel.SetPersonalNr(const Value: string);
begin
  FPersonalNr := Value;
end;

procedure TUserModel.SetPlz(const Value: string);
begin
  FPlz := Value;
end;

procedure TUserModel.SetRemote_User(const Value: string);
begin
  FRemote_User := Value;
end;

procedure TUserModel.SetResult(const Value: TResultModel);
begin
  FResult := Value;
end;

procedure TUserModel.SetStrasse(const Value: string);
begin
  FStrasse := Value;
end;

procedure TUserModel.SetTelefon(const Value: string);
begin
  FTelefon := Value;
end;

procedure TUserModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['PersonalNr'] <> nil then
    Self.PersonalNr := string(obj['PersonalNr']);
  if obj['Name'] <> nil then
    Self.Name := string(obj['Name']);
  if obj['Vorname'] <> nil then
    Self.Vorname := string(obj['Vorname']);
  if obj['Remote_User'] <> nil then
    Self.remote_User := string(obj['Remote_User']);
  if obj['Strasse'] <> nil then
    Self.Strasse := string(obj['Strasse']);
  if obj['Plz'] <> nil then
    Self.Plz := string(obj['Plz']);
  if obj['Ort'] <> nil then
    Self.Ort := string(obj['Ort']);
  if obj['Telefon'] <> nil then
    Self.Telefon := string(obj['Telefon']);
  if obj['Handy'] <> nil then
    Self.Handy := string(obj['Handy']);
  if obj['Email'] <> nil then
    Self.Email := string(obj['Email']);
  if obj['InfoMail'] <> nil then
    Self.InfoMail := StrToBoolean(string(obj['InfoMail']));
end;

procedure TUserModel.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

procedure TUserModel.SetVorname(const Value: string);
begin
  FVorname := Value;
end;

function TUserModel.ToJson: string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', Self.PersonalNr);
  obj.AddPair('Name', Self.Name);
  obj.AddPair('Vorname', Self.Vorname);
  obj.AddPair('Remote_User', Self.remote_User);
  obj.AddPair('Strasse', Self.Strasse);
  obj.AddPair('Plz', Self.Plz);
  obj.AddPair('Ort', Self.Ort);
  obj.AddPair('Telefon', Self.Telefon);
  obj.AddPair('Handy', Self.Handy);
  obj.AddPair('Email', Self.Email);
  obj.AddPair('InfoMail', BooleanToStr(Self.InfoMail));
  Result := obj.ToString;
  obj.Free;
end;

function TUserModel.ToString: string;
begin
  if Self.Vorname <> '' then
    Result := Self.Vorname + ' ' + Self.Name
  else
    Result := Self.Name;
end;

procedure TUserModel.Update(url: string);
var
  client: TRestClient;
  obj: TJsonObject;
  procedure Response(Sender: TObject; AResponse: string);
  begin
    Self.Result := TResultModel.Create(AResponse);
    Self.PropertyChanged;
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('value', Self.ToJson);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(url + '/PersonalService/PostUser', 'application/json',
    obj.ToString);
  client.Free;
end;

procedure TUserModel.UpdatePassword(url, newPassword: string);
var
  obj: TJsonObject;
  json: string;
  client: TRestClient;
  procedure Response(Sender: TObject; AResponse: string);
  begin
    Self.Result := TResultModel.Create(AResponse);
    Self.PropertyChanged;
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', Self.PersonalNr);
  obj.AddPair('Password', newPassword);
  json := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', json);
  json := obj.ToString;
  obj.Free;
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(url + '/PersonalService/UpdatePw', 'application/json', json);
  client.Free;
end;

procedure TUserModel.UpdateRemoteUser(url, remoteUserNew: string);
var
  obj: TJsonObject;
  json: string;
  client: TRestClient;
  procedure Response(Sender: TObject; AResponse: string);
  begin
    Self.Result := TResultModel.Create(AResponse);
    Self.PropertyChanged;
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', Self.PersonalNr);
  obj.AddPair('RemoteUser', remoteUserNew);
  json := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', json);
  json := obj.ToString;
  obj.Free;
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(url + '/PersonalService/UpdateRemoteUser',
    'application/json', json);
  client.Free;
end;

end.
